import { DatePipe, formatDate, JsonPipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
import * as XLSX from 'xlsx';
// interface ItemData {
//   ID: string;
//   RATE_PER_HOUR: string;
//   TOTAL_AMOUNT: number;
//   // address: string;
// }
@Component({
  selector: 'app-employee-time-utilization-report',
  templateUrl: './employee-time-utilization-report.component.html',
  styleUrls: ['./employee-time-utilization-report.component.css'],
})
export class EmployeeTimeUtilizationReportComponent implements OnInit {
  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService,
    private _exportService: ExportService
  ) {}

  formTitle = 'Published Employee Wise Project Billing';

  ngOnInit(): void {
    this.loadAllAssignee();
    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.onMonthChange(this.month);
    // this.findTotalDays(this.year, this.month);
  }

  dt = new Date();
  month: any = new Date();
  year: any = new Date();
  START_DATE: any;
  END_DATE: any;
  radioValue = 'E';

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = 'desc';
  logtext: string = '';
  searchText: string = '';
  columns: string[][] = [
    ['NAME', 'Name'],
    ['DATE', 'Date'],
  ];
  filterQuery: string = '';
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectData2 = [];
  projectDataForExcel = [];
  date = new Date();
  pushCheck = [];
  pushCheck2 = [];
  previousandcurrentTimeValues: any = {};
  // This function stores the previous value when the time field is clicked
  // Store the previous value when the time input is clicked (on initial change)
  getValues(
    event,
    employeetime: any,
    tempMinutes: any,
    employeedata: string,
    p: string,
    i: number,
    j: number
  ): void {
    const hoursKey = `${p}_HOURS`; // Key for hours
    // 

    // const minutesKey = `tempMinutes`; // Key for minutes
    // 
    if (!employeedata[hoursKey]) {
      employeedata[hoursKey] = 0;
    }
    if(!tempMinutes){
      tempMinutes=0
    }
    const time = employeedata[hoursKey] + ':' + tempMinutes + ':' + '00';
    const hoursandminseconds = this.convertToSeconds(time);
    // const currenttimeinseconds=this.convertToSeconds(employeetime)
    this.previousandcurrentTimeValues = {
      oldTimeinSeconds: hoursandminseconds,
    };
    // 
    //   'currenttimesec',
    //   hoursandminseconds,
    //   time,
    //   this.previousandcurrentTimeValues
    // );

    // Combine hours and minutes to form a time string (HH:mm:ss)

    // After saving the time, recalculate the total hours and amount
    // this.calculateTotalAmountAndHours(employee, p, i, j);
  }

  onTimeChange(
    hours: number,
    minutes: number,
    employee: any,
    p: string,
    i: number,
    j: number
  ): void {
    // let totalAmount = 0;
    // 
   
    if (hours || minutes) {
      if (!hours) {
        hours = 0;
      }
      if(!minutes){
        minutes=0
      }
      const time = Number(hours) + ':' + Number(minutes) + ':' + '00';
      const newtimeinseconds = this.convertToSeconds(time);
      // 
      //   `onTimeChange triggered with hours: ${hours}, minutes: ${minutes}`,
      //   this.previousandcurrentTimeValues,
      //   newtimeinseconds
      // );
      // if(this.previousandcurrentTimeValues.oldTimeinSeconds
      //   >newtimeinseconds){
      const newTime = newtimeinseconds / 3600;
      employee[p + '_AMOUNT'] = employee.RATE_PER_HOUR * newTime;
      // 
      employee[p + '_TIME'] = time;
      // totalAmount = employee[p + '_AMOUNT'];
      // employee.TOTAL_AMOUNT+=totalAmount
      let totalhours;
      totalhours = this.convertTimeToSeconds(employee.TOTAL_HOURS);
      totalhours =
        totalhours - this.previousandcurrentTimeValues.oldTimeinSeconds;

      totalhours = totalhours + newtimeinseconds;
      employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      // 
      //   totalhours,
      //   'new greater',
      //   this.previousandcurrentTimeValues.oldTimeinSeconds,
      //   newtimeinseconds
      // );

      // if (
      //   this.previousandcurrentTimeValues.oldTimeinSeconds > newtimeinseconds
      // ) {
      //   // 

      //   const totaltime = this.convertTimeToSeconds(employee.TOTAL_HOURS);

      //   if (
      //     totaltime >
      //     this.previousandcurrentTimeValues.oldTimeinSeconds + newtimeinseconds
      //   ) {
      //     totalhours =
      //       totaltime -
      //       this.previousandcurrentTimeValues.oldTimeinSeconds +
      //       newtimeinseconds;
      //   } else {
      //     totalhours =
      //       this.previousandcurrentTimeValues.oldTimeinSeconds +
      //       newtimeinseconds -
      //       totaltime;
      //   }
      //   employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      //   employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      //   

      //   // this.employeeData = this.calculateTotalDays(this.employeeData);
      //   // this.calculateColumnTotals();
      //   // this.getValues(hours, minutes, employee, p, i, j);
      // } else {
      //   const totaltime = this.convertTimeToSeconds(employee.TOTAL_HOURS);
      //   let totalhours;
      //   if (
      //     totaltime >
      //     this.previousandcurrentTimeValues.oldTimeinSeconds + newtimeinseconds
      //   ) {
      //     totalhours =
      //       totaltime -
      //       this.previousandcurrentTimeValues.oldTimeinSeconds +
      //       newtimeinseconds;
      //     
      //   } else {
      //     totalhours =
      //       newtimeinseconds +
      //       this.previousandcurrentTimeValues.oldTimeinSeconds -
      //       totaltime;
      //     
      //   }
      //   employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      //   employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      //   
      //     totaltime,
      //     totalhours,
      //     'new greater',
      //     this.previousandcurrentTimeValues.oldTimeinSeconds,
      //     newtimeinseconds,
      //     totaltime
      //   );
      // }

      this.employeeData = this.calculateTotalDays(this.employeeData);
      this.calculateColumnTotals();
      this.getValues('', hours, minutes, employee, p, i, j);
    } else {
      hours = 0;
      minutes =0;
      employee[p + '_HOURS'] = 0;
      employee[p + '_tempMinutes'] = 0;
      employee[p + '_AMOUNT'] = 0;
      // 
      employee[p + '_TIME'] = '00:00:00';
      // 
      const time = Number(hours) + ':' + Number(minutes) + ':' + '00';
      const newtimeinseconds = this.convertToSeconds(time);
      // 
      //   `onTimeChange triggered with hours: ${hours}, minutes: ${minutes}`,
      //   this.previousandcurrentTimeValues,
      //   newtimeinseconds
      // );
      // if(this.previousandcurrentTimeValues.oldTimeinSeconds
      //   >newtimeinseconds){
      const newTime = newtimeinseconds / 3600;
      employee[p + '_AMOUNT'] = employee.RATE_PER_HOUR * newTime;
      // 
      employee[p + '_TIME'] = time;
      // totalAmount = employee[p + '_AMOUNT'];
      // employee.TOTAL_AMOUNT+=totalAmount
      let totalhours;
      totalhours = this.convertTimeToSeconds(employee.TOTAL_HOURS);
      totalhours =
        totalhours - this.previousandcurrentTimeValues.oldTimeinSeconds;

      totalhours = totalhours + newtimeinseconds;
      employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      this.employeeData = this.calculateTotalDays(this.employeeData);
      this.calculateColumnTotals();
      this.getValues('', hours, minutes, employee, p, i, j);

      // const time=hours+':'+minutes+':'+'00'
      // const newtimeinseconds=this.convertToSeconds(time)
      // 
      //   `onTimeChange triggered with hours: ${hours}, minutes: ${minutes}`,this.previousandcurrentTimeValues,newtimeinseconds
      // );
      // if(this.previousandcurrentTimeValues>newtimeinseconds){
      //   
      // }
      // else{
      //   
      // }
    }
    // let valuetime=
    // Ensure the hours are within a reas
    // onable range
    // 
  }
  onMinuteChange(
    hours: number,
    minutes: number,
    employee: any,
    p: string,
    i: number,
    j: number
  ) {
    // 
   
    if (hours || minutes) {
      if (!hours) {
        hours = 0;
      }
      if(!minutes){
        minutes=0
      }
      const time = hours + ':' + minutes + ':' + '00';
      const newtimeinseconds = this.convertToSeconds(time);
      // 

      // 
      //   `onMinuteChange triggered with hours: ${
      //     employee[p + '_HOURS']
      //   }, minutes: ${minutes}`,
      //   this.previousandcurrentTimeValues,
      //   newtimeinseconds
      // );

      employee[p + '_AMOUNT'] =
        employee.RATE_PER_HOUR * (newtimeinseconds / 3600);
      employee[p + '_TIME'] = time;
      let totalhours;
      totalhours = this.convertTimeToSeconds(employee.TOTAL_HOURS);
      totalhours =
        totalhours - this.previousandcurrentTimeValues.oldTimeinSeconds;
      totalhours = totalhours + newtimeinseconds;

      employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      // 
      //   totalhours,
      //   'new greater',
      //   this.previousandcurrentTimeValues.oldTimeinSeconds,
      //   newtimeinseconds
      // );
      this.employeeData = this.calculateTotalDays(this.employeeData);
      this.calculateColumnTotals();
      this.getValues('', hours, minutes, employee, p, i, j);
    } else {
      // hours=0
      // minutes = 0;
      // employee[p + '_tempMinutes'] = 0;
      // employee[p + '_HOURS'] = 0;
      // employee[p + '_AMOUNT'] = 0;
      // // 
      // employee[p + '_TIME'] = '00:00:00';
      // 
      hours = 0;
      minutes =0;
      employee[p + '_HOURS'] = 0;
      employee[p + '_tempMinutes'] = 0;
      employee[p + '_AMOUNT'] = 0;
      // 
      employee[p + '_TIME'] = '00:00:00';
      // 
      const time = Number(hours) + ':' + Number(minutes) + ':' + '00';
      const newtimeinseconds = this.convertToSeconds(time);
      // 
      //   `onTimeChange triggered with hours: ${hours}, minutes: ${minutes}`,
      //   this.previousandcurrentTimeValues,
      //   newtimeinseconds
      // );
      // if(this.previousandcurrentTimeValues.oldTimeinSeconds
      //   >newtimeinseconds){
      const newTime = newtimeinseconds / 3600;
      employee[p + '_AMOUNT'] = employee.RATE_PER_HOUR * newTime;
      // 
      employee[p + '_TIME'] = time;
      // totalAmount = employee[p + '_AMOUNT'];
      // employee.TOTAL_AMOUNT+=totalAmount
      let totalhours;
      totalhours = this.convertTimeToSeconds(employee.TOTAL_HOURS);
      totalhours =
        totalhours - this.previousandcurrentTimeValues.oldTimeinSeconds;

      totalhours = totalhours + newtimeinseconds;
      employee.TOTAL_HOURS = this.convertToHHMMSS(totalhours);
      employee.TOTAL_AMOUNT = (totalhours / 3600) * employee.RATE_PER_HOUR;
      this.employeeData = this.calculateTotalDays(this.employeeData);
      this.calculateColumnTotals();
      this.getValues('', hours, minutes, employee, p, i, j);
    }
    // 
  }

  // This function updates the employee's data when time is changed
  // This function updates the employee's data when time is changed

  convertToSeconds(time: string): number {
    // Ensure time is a string and handle null or undefined cases
    if (typeof time !== 'string' || !time) {
      return 0; // Return 0 if the time is not a valid string
    }

    const timeParts = time.split(':');
    if (timeParts.length !== 3) return 0; // Invalid time format
    const [hours, minutes, seconds] = timeParts;
    // 
    return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
  }

  convertToHHMMSS(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;
    // 

    return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(
      sec
    )}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
  isValidTimeFormat(value: string): boolean {
    const timeRegex = /^([0-9]+):([0-5][0-9]):([0-5][0-9])$/;
    return timeRegex.test(value);
  }
  // Hel method to convert time to seconds
  convertTimeToSeconds(time: any): number {
    if (typeof time === 'string') {
      const [hours, minutes, seconds] = time.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    }
    // 

    const hours = time.getHours();
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();
    return hours * 3600 + minutes * 60 + seconds;
  }

  formatTime3(hours: number, minutes: number): string {
    // Ensure hours and minutes are two digits
    const paddedHours = hours < 10 ? '0' + hours : hours;
    const paddedMinutes = minutes < 10 ? '0' + minutes : minutes;

    // Return the formatted time string
    return `${paddedHours}:${paddedMinutes}:00`; // Assuming no seconds are needed
  }
  // Helper method to format seconds back to HH:mm:ss
  formatTime(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getMonthAndYear() {
    this.month = new Date(this.dt.getFullYear(), this.dt.getMonth(), 1);
    this.year = new Date(this.dt.getFullYear(), 0, 1);
    this.isFilterApplied = 'primary';
    // this.updateEditCache()
  }

  onMonthChange(selectedMonth: Date): void {
    if (selectedMonth) {
      const year = selectedMonth.getFullYear();
      const month = selectedMonth.getMonth();

      // Calculate the first and last day of the month
      this.START_DATE = new Date(year, month, 1);
      this.END_DATE = new Date(year, month + 1, 0);
      this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
      // this.getAllEmployeeWiseHoursDetails(true)
      // 
      // 
    }
    this.getAllEmployeeWiseHoursDetails(true);
  }

  convertToTime(timeString: string): Date {
    if (!timeString) return null;

    // Parse string format HH:mm:ss to a Date object
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours || 0, minutes || 0, seconds || 0);
    return date;
  }

  convertToTimeString(date: Date): string {
    if (!date) return null;

    // Convert Date object back to HH:mm:ss string format
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  updatemonthrecords: boolean = false;
  convertToHHMMSS2(dateInput: any): string {
    const date = new Date(dateInput);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
  isVisibleFinalize = true;
  UpdateMonthData(): void {
    // Check if the project data is empty
    if (!this.employeeData || this.employeeData.length === 0) {
      this.notificationService.error('Project list is empty', '');
      return;
    }

    //   // Check if any PENDING value is negative and log the rows with negative values
    // const invalidRows = this.projectData.filter(project => project.PENDING < 0);
    // if (invalidRows.length > 0) {
    //   // Log the rows with invalid (negative) PENDING values
    //   
    //   this.notificationService.error('Pending amount cannot be negative for  project ' + invalidRows[0]['PROJECT_NAME'], '');
    //   return;
    // }

    this.loadingRecords = true;

    this.projectData2 = JSON.parse(JSON.stringify(this.employeeData));

    // Remove all `TOTAL_DAYS` fields from `projectData2`
    this.projectData2.forEach((project: any) => {
      delete project.TOTAL_DAYS;
      this.maxColumns.forEach((data) => {
        delete project[data + '_HOURS'];
        delete project[data + '_tempMinutes'];
      });
    });

    const dataToSave = {
      startDate: this.START_DATE,
      endDate: this.END_DATE,
      projectData: this.projectData2,
    };

    this.updatemonthrecords = true;
    this._apiService.updateeditedMonthData(dataToSave).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.notificationService.success(
            'Month Data updated successfully',
            ''
          );
          this.isVisibleFinalize = true;
          this.isVisible = false;
        } else {
          this.notificationService.error('Failed to push data', '');
        }
        this.loadingRecords = false;
        this.updatemonthrecords = false;
      },
      (error) => {
        console.error('Error:', error);
        this.notificationService.error(
          'An error occurred while updating data',
          ''
        );
        this.loadingRecords = false;
        this.updatemonthrecords = false;
      }
    );
  }
  finalizeLoading = false;
  finalize() {
    this.finalizeLoading = true;
    var data = {
      startDate: this.START_DATE,
      endDate: this.END_DATE,
    };
    this._apiService.finanizeMonthData(data).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.finalizeLoading = false;
          this.notificationService.success('Finalization Successfull', '');
          // this.loadingRecords = false;
          this.getAllEmployeeWiseHoursDetails();
          this.finalizeLoading = false;
          this.isVisibleFinalize = false;
        } else {
          this.notificationService.success('Finalization failed', '');
          // this.loadingRecords = false;
          this.finalizeLoading = false;
        }
      },
      (error) => {
        console.error('Error:', error);
        this.notificationService.error(
          'An error occurred while updating data',
          ''
        );
        this.loadingRecords = false;
        this.updatemonthrecords = false;
      }
    );
  }
  // private cachedMaxColumns: string[] = [];
  // extractMaxColumns(data: any[]) {
  //   const projectKeys = new Set<string>();

  //   for (const employee of data) {
  //     Object.keys(employee)
  //       .filter((key) => key.endsWith('_TIME'))
  //       .forEach((key) => projectKeys.add(key.slice(0, -5))); // Slice '_TIME'
  //   }

  //   return [...projectKeys]; // Return an array of unique project keys
  // }
  originalData: any = [];
  isFinalized = 0;
  getAllEmployeeWiseHoursDetails(reset: boolean = false): void {
    // if (this.MODULE_ASSIGNEE_ID.length === 0) {
    //   this.notificationService.error('No module assignee selected', '');
    //   return;
    // }

    if (reset) this.pageIndex = 1;

    this.loadingRecords = true;

    this._apiService
      .getemployeePushedReport(this.START_DATE, this.END_DATE)
      .subscribe({
        next: (data) => {
          if (data['code'] == 200) {
            this.loadingRecords = false;
            this.isProjectSpinning = false;
            this.totalRecords = data['count'];
            this.isFinalized = data['IS_FINALIZED'];
            this.employeeData = data['results'];
            this.isFilterApplied = 'primary';
            this.originalData = data['results'];
            const projectKeys = new Set<string>();
            this.employeeData.forEach((employee) => {
              Object.keys(employee).forEach((key) => {
                if (key.endsWith('_TIME')) {
                  const projectName = key.replace('_TIME', '');
                  projectKeys.add(projectName); // Add unique project name
                }
              });
            });

            this.maxColumns = Array.from(projectKeys);
            this.employeeData.forEach((employee) => {
              this.maxColumns.forEach((column) => {
                const timeKey = `${column}_TIME`;
                if (employee[timeKey]) {
                  const [hours, minutes] = employee[timeKey].split(':'); // Split time into hours and minutes
                  // 
                  employee[column + '_HOURS'] = hours; // Store the hours
                  employee[column + '_tempMinutes'] = minutes; // Store the minutes
                  // 
                }
              });
            });
            // this.employeeData.forEach((data) => {
            //   this.maxColumns.forEach((column) => {
            //     const timeKey = `${column}_TIME`;
            //     if (data[timeKey]) {
            //       data[timeKey] = this.convertToTime(data[timeKey]);
            //     }
            //   });
            // });
            var d = this.maxColumns.length * 230;
            this.scroll = { x: d + 'px', y: '400px' };
            this.employeeData = this.calculateTotalDays(this.employeeData);
            this.calculateColumnTotals();
          } else {
            // this.notificationService.error('Failed To get Records', '');
            this.employeeData = [];
            this.maxColumns = [];
            this.totals = {
              RATE_PER_HOUR: 0,
              TOTAL_AMOUNT: 0,
              TOTAL_HOURS: 0,
              TOTAL_DAYS: 0,
            };
            this.isFilterApplied = 'default';
            this.loadingRecords = false;
          }
        },
        error: (err) => {
          this.loadingRecords = false;
          const errorMsg =
            err.status === 404 ? 'Server Not Found' : 'An error occurred';
          this.notificationService.error(errorMsg, '');
          this.employeeData = [];
          this.maxColumns = [];
          this.loadingRecords = false;
          this.totals = {
            RATE_PER_HOUR: 0,
            TOTAL_AMOUNT: 0,
            TOTAL_HOURS: 0,
            TOTAL_DAYS: 0,
          };
        },
      });
  }
  calculateTotalDays(employeeData: any[]): any[] {
    return employeeData.map((employee) => {
      if (employee.TOTAL_HOURS) {
        // 

        // Split the TOTAL_HOURS into hours, minutes, and seconds
        const timeParts = employee.TOTAL_HOURS.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        // Verify the values parsed
        // 
        //   `Parsed Time: hours=${hours}, minutes=${minutes}, seconds=${seconds}`
        // );

        // Calculate the total hours
        const totalHours = hours + minutes / 60 + seconds / 3600;

        // Calculate the total days by dividing the total hours by 24
        const totalDays = totalHours / 8;

        // 

        // Add the TOTAL_DAYS to the employee record
        return {
          ...employee,
          TOTAL_DAYS: totalDays.toFixed(2), // Rounded to 2 decimal places
        };
      }

      // If there is no TOTAL_HOURS, return the employee data as is
      return employee;
    });
  }
  filterClass: string = 'filter-invisible';
  isFilterApplied: string = 'default';

  applyFilter() {
    // this.getMonthAndYear();
    // this.getDaysOfMonth(this.month, this.year);
    this.getAllEmployeeWiseHoursDetails();
    this.filterClass = 'filter-invisible';
  }

  showFilter(): void {
    if (this.filterClass === 'filter-visible')
      this.filterClass = 'filter-invisible';
    else this.filterClass = 'filter-visible';
  }

  clearFilter() {
    this.filterQuery = '';

    this.isFilterApplied = 'default';
    this.filterClass = 'filter-invisible';

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.TYPE = '';
    this.str = '';

    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.getAllEmployeeWiseHoursDetails(true);
    this.radioValue = 'E';
  }

  sortKey: string = 'id';

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'asc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;

    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getAllEmployeeWiseHoursDetails();
    }
  }

  onChange(result: Date): void {
    this.dt = result;
  }
  // employeeProjectTimeChange(data, event) {
  //   // 
  // }
  employeerateChange(event, data, i) {
    // 
    // 

    // Convert TOTAL_HOURS to seconds
    this.isVisibleFinalize = false;
    const newTimeInSeconds = this.convertTimeToSeconds(data.TOTAL_HOURS);
    const hours = newTimeInSeconds / 3600;
    // 
    
    if (event) {
      // Update the total amount based on RATE_PER_HOUR
      data.TOTAL_AMOUNT = hours * data.RATE_PER_HOUR;

      // Iterate over maxColumns and update the corresponding amount column
      this.maxColumns.forEach((column) => {
        const columnTimeKey = column + '_TIME';
        const columnAmountKey = column + '_AMOUNT';

        // Check if the column time exists and calculate the amount
        if (data[columnTimeKey]) {
          // 

          const columnTimeInSeconds = this.convertTimeToSeconds(
            data[columnTimeKey]
          );
          const columnHours = columnTimeInSeconds / 3600;
          // 
          data[columnAmountKey] = columnHours * data.RATE_PER_HOUR;
        } else {
          // If no time value is present, reset the amount
          data[columnAmountKey] = 0;
          const columnTimeInSeconds = this.convertTimeToSeconds(
            data[columnTimeKey]
          );
          const columnHours =columnTimeInSeconds / 3600;
          data[columnAmountKey] = columnHours * data.RATE_PER_HOUR;
        }
      });
      this.calculateColumnTotals();
    }
  }
  days = new Array();

  getDaysOfMonth(MM, yyyy) {
    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');

    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    this.getDaysArray(this.START_DATE, this.END_DATE);
  }

  getDaysArray(start, end) {
    for (
      var arr = [], dt = new Date(start);
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 1)
    ) {
      arr.push(this.datePipe.transform(dt, 'yyyy-MM-dd'));
      this.days.push(this.datePipe.transform(dt, 'yyyy-MM-dd'));
    }
    return arr;
  }

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date();
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  onEnterGetAllEmployeeWiseHoursDetails() {
    document.getElementById('button1').focus();
    this.getAllEmployeeWiseHoursDetails(true);
  }
  loadprojectexcel: boolean = false;
  convertSecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padWithZero(hours)}:${this.padWithZero(
      minutes
    )}:${this.padWithZero(remainingSeconds)}`;
  }
  padWithZero(value) {
    return value < 10 ? '0' + value : value;
  }
  disabledDate = (current: Date): boolean => {
    const today = new Date();
    // Set the time to 0 to ignore time differences
    today.setHours(0, 0, 0, 0);

    // Disable months after the current month of the current year
    return (
      current &&
      (current.getFullYear() > today.getFullYear() ||
        (current.getFullYear() === today.getFullYear() &&
          current.getMonth() > today.getMonth()))
    );
  };
  fireEvent() {
    this.loadprojectexcel = true;

    // Collect all unique project names from employeeData keys
    const projectKeys = new Set();
    this.employeeData.forEach((employee) => {
      Object.keys(employee).forEach((key) => {
        if (key.endsWith('_TIME')) {
          const projectName = key.replace('_TIME', '');
          projectKeys.add(projectName); // Add unique project name
        }
      });
    });

    this.maxColumns = Array.from(projectKeys);

    // Prepare header rows
    const headerRow1 = [
      'Employee Name',
      'Rate Per Hour',
      'Total Amount',
      'Total Hours',
      ...this.maxColumns.flatMap((project) => [project, '']),
      'Total Days',
    ];

    const headerRow2 = [
      '',
      '',
      '',
      '',
      ...this.maxColumns.flatMap(() => ['TIME', 'AMOUNT']),
      '',
    ];

    // Prepare data rows and calculate totals
    let totalTime = 0;
    let totalAmount = 0;
    let totalRate = 0;
    let totalDays = 0;
    let projectTimes: any = new Array(this.maxColumns.length).fill(0);
    let projectAmounts = new Array(this.maxColumns.length).fill(0);

    const employeeRows = this.employeeData.map((employee) => {
      if (employee.EMP_NAME === 'Total') {
        return null;
      }

      const row = [
        employee.EMP_NAME,
        employee.RATE_PER_HOUR,
        employee.TOTAL_AMOUNT,
        this.formatTime2(employee.TOTAL_HOURS),
        ...this.maxColumns.flatMap((projectName) => {
          const timeKey = `${projectName}_TIME`;
          const amountKey = `${projectName}_AMOUNT`;

          let time = employee[timeKey] || '';
          const amount = employee[amountKey] || '';

          if (time) {
            time = time; // Format time properly
            projectTimes[this.maxColumns.indexOf(projectName)] +=
              this.convertTimeToSeconds(time);
          }
          if (amount) {
            projectAmounts[this.maxColumns.indexOf(projectName)] += amount;
          }

          return [time, amount];
        }),
        // Format time properly
        employee.TOTAL_DAYS,
      ];

      totalTime += this.convertTimeToSeconds(employee.TOTAL_HOURS) || 0;
      totalAmount += employee.TOTAL_AMOUNT || 0;
      totalRate += employee.RATE_PER_HOUR || 0;
      totalDays += parseFloat(employee.TOTAL_DAYS) || 0;
      return row;
    });

    const row2 = ['', '', '', '', '', ''];
    // Add the "Total" row with aggregated data

    const totalRow = [
      'Total',
      totalRate,
      totalAmount,
      this.formatTime(totalTime),
      ...projectTimes.flatMap((time, index) => {
        const amount = projectAmounts[index];
        return [this.convertSecondsToTime(time), amount]; // Format time properly
      }),
      // Format time properly
      totalDays,
    ];

    // Combine headers and data into one array for Excel export
    const worksheetData = [
      headerRow1,
      headerRow2,
      ...employeeRows,
      row2,
      totalRow,
    ];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Merge cells for project names
    const merges = this.maxColumns.map((_, index) => ({
      s: { r: 0, c: 4 + index * 2 },
      e: { r: 0, c: 5 + index * 2 },
    }));
    ws['!merges'] = merges;

    // Define column widths
    ws['!cols'] = [
      { wch: 15 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      ...this.maxColumns.flatMap(() => [{ wch: 20 }, { wch: 10 }]),
    ];
    const headerCellStyle = {
      font: {
        bold: true, // Make text bold
        color: {
          rgb: 'FFFFFF', // Set the font color to white
        },
      },
      fill: {
        fgColor: {
          rgb: '4F81BD', // Set the background color to blue (4F81BD)
        },
      },
      alignment: {
        horizontal: 'center', // Center align text horizontally
        vertical: 'center', // Center align text vertically
      },
    };

    // Apply styles to header rows
    for (let i = 0; i < headerRow1.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow1[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    for (let i = 0; i < headerRow2.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow2[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');

    // Save to file
    XLSX.writeFile(wb, 'Published Employee Wise Project Billing.xlsx');
    this.loadprojectexcel = false;
  }

  // Utility function to format time
  formatTime2(time: any): string {
    if (time instanceof Date) {
      // Format Date object to hh:mm:ss
      return time.toTimeString().split(' ')[0];
    }

    if (typeof time === 'number') {
      // If it's a number (e.g., seconds), convert it to hh:mm:ss
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    if (typeof time === 'string') {
      // Handle time string (e.g., 'hh:mm:ss')
      const timeStr = time.trim();
      const match = timeStr.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
      if (match) {
        return `${match[1].padStart(2, '0')}:${match[2]}:${match[3]}`;
      }
    }

    // Default to 00:00:00 if the input is invalid
    return '00:00:00';
  }

  assigneeList = [];
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService
      .getAllUsers(0, 0, 'ID', 'desc', ' AND IS_ACTIVE=1')
      .subscribe(
        (userData) => {
          if (userData['code'] == 200) {
            this.assigneeList = userData['data'];
            var userCategory = this.assigneeList.filter(
              (x) => x.ID == this._apiService.userId
            );
            if (userCategory != null && userCategory != undefined) {
              this.categoryID = userCategory[0]['TASK_CATEGORY_ID'];
            } else {
              this.categoryID = 0;
            }
            this.loadAllRoles();
          }
        },
        (err) => {}
      );
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get('level');
    var nextLevel = Number(this.cookie.get('level')) + 1;
    if (this.cookie.get('level') == '1' || this.cookie.get('level') == '2') {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(
        (data) => {
          if (data['code'] == 200) {
            this.roleData = data['data'];
            this.findNewAssigneeList();
            if (this.MODULE_ASSIGNEE_ID.length != 0) {
              this.getAllEmployeeWiseHoursDetails(true);
            }
          }
        },
        (err) => {}
      );
    } else {
      this._apiService
        .getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')')
        .subscribe(
          (data) => {
            if (data['code'] == 200) {
              this.roleData = data['data'];

              this.findNewAssigneeList();
              if (this.MODULE_ASSIGNEE_ID.length != 0) {
                this.getAllEmployeeWiseHoursDetails(true);
              }
            }
          },
          (err) => {}
        );
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = '';

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (
          Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']
        ) {
          if (
            this.cookie.get('level') == '1' ||
            this.cookie.get('level') == '2' ||
            this.cookie.get('level') == '3'
          ) {
            this.newAssigneeList.push(this.assigneeList[k]);
          } else if (this.cookie.get('level') == '4') {
            if (
              Number(this.assigneeList[k]['TASK_CATEGORY_ID']) ==
              this.categoryID
            ) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
    }

    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
  }

  projectID = [];
  projectList = [];

  loadAllProjects(str) {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(
      (projectData) => {
        if (projectData['code'] == 200) {
          this.projectList = projectData['data'];
          for (var i = 0; i < this.projectList.length; i++) {
            this.projectID.push(this.projectList[i]['ID']);
          }
        }
      },
      (err) => {}
    );
  }

  str = '';

  onStatusChange(type) {
    this.projectID = [];

    if (type == 'B') {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=1';
    } else if (type == 'NB') {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=0';
    } else if (type == null) {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE in (0,1)';
    }

    this.loadAllProjects(this.str);
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + -1);

      return endValue <= new Date(previousDate);
    }
  };

  employeeData: any = [];

  maxColumns: any;
  scroll: any;
  // calculateScrollWidth(): void {
  //   const fixedWidth = 700; // Fixed column widths (e.g., Edit, Employee Name, etc.)
  //   const dynamicColumnWidth = this.maxColumns.length * 280; // Assuming each column takes 280px
  //   this.scrollWidth = `${fixedWidth + dynamicColumnWidth}px`;
  // }
  trackByColumn(index: number, item: string): string {
    return item;
  }

  // TrackBy for employee rows
  trackByEmployee(index: number, item: any): string {
    return item.EMP_NAME;
  }
  totals: any = {};
  calculateColumnTotals(): any {
    const totals: any = {
      RATE_PER_HOUR: 0,
      TOTAL_AMOUNT: 0,
      TOTAL_HOURS: 0,
      TOTAL_DAYS: 0,
    };

    if (Array.isArray(this.maxColumns)) {
      this.maxColumns.forEach((col) => {
        totals[col] = { totalTime: 0, totalAmount: 0 };
      });

      this.employeeData.forEach((employee) => {
        totals.RATE_PER_HOUR += this.parseNumber(employee.RATE_PER_HOUR);
        totals.TOTAL_AMOUNT += this.parseNumber(employee.TOTAL_AMOUNT);

        totals.TOTAL_HOURS += this.convertToSeconds(
          employee.TOTAL_HOURS || '00:00:00'
        );
        totals.TOTAL_DAYS += this.parseNumber(employee.TOTAL_DAYS);
        this.maxColumns.forEach((col) => {
          // 
          totals[col].totalTime += this.convertToSeconds(
            employee[`${col}_TIME`] || '00:00:00'
          );
          totals[col].totalAmount += this.parseNumber(
            employee[`${col}_AMOUNT`] || 0
          );
        });
      });
    }

    return (this.totals = totals);
  }

  parseNumber(value: any): number {
    return isNaN(Number(value)) ? 0 : Number(value);
  }

  // convertToSeconds(time: string | Date): number {
  //   if (time) {
  //     if (typeof time === 'string') {
  //       const [hours, minutes, seconds] = time.split(':').map(Number);
  //       return (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
  //     } else if (time instanceof Date) {
  //       return (
  //         time.getHours() * 3600 + time.getMinutes() * 60 + time.getSeconds()
  //       );
  //     }
  //     throw new Error('Invalid time format');
  //   }
  // }
  // convertToHHMMSS(totalSeconds: number): string {
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = totalSeconds % 60;

  //   // Return formatted time string
  //   return [hours, minutes, seconds]
  //     .map((unit) => String(unit).padStart(2, '0')) // Ensure two-digit format
  //     .join(':');
  // }

  // formatTime(totalSeconds: number): string {
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = totalSeconds % 60;
  //   return [hours, minutes, seconds]
  //     .map((unit) => String(unit).padStart(2, '0'))
  //     .join(':');
  // }

  formatAmount(amount: number): string {
    return amount.toFixed(2);
  }
  omit(event: any) {
    // 

    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }
  omit2(event: any) {
    // 

    const charCode = event.which ? event.which : event.keyCode;
    // Check if the character is not a number and not a colon
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 58) {
      return false;
    }

    return true;
  }
  isVisible = false;
  displaytotalamountsandtime={}
  openModal(): void {
    const totals={
      TOTAL_AMOUNT: 0,
      TOTAL_HOURS: 0,
    }
    // this.loadingRecords = true;
    this.isVisible = true;
    this.maxColumns.forEach((col) => {
      totals[col] = { totalTime: 0, totalAmount: 0 };
    });
    this.employeeData.forEach(employee=>{
      totals.TOTAL_AMOUNT += this.parseNumber(employee.TOTAL_AMOUNT);

      totals.TOTAL_HOURS += this.convertToSeconds(
        employee.TOTAL_HOURS || '00:00:00'
      );
      this.maxColumns.forEach((col) => {
        // 
       
        totals[col].totalTime += this.convertToSeconds(
          employee[`${col}_TIME`] || '00:00:00'
        );
        totals[col].totalAmount += this.parseNumber(
          employee[`${col}_AMOUNT`] || 0
        );
      
        
      });
     
    })
   
    // this.loadPushData =  true ;
    this.displaytotalamountsandtime = totals
    
  }

  handleCancel(): void {
    this.isVisible = false;
  }
}
